const DEFAULT_ICONS = new Map([
    ['TELIA_TV_FOXPLAY_E', { modifier: 'logo-foxplay', label: 'Fox Play' }],
    ['TELIA_TV_SALVESTUS_E', { modifier: 'record' }],
    ['TELIA_TV_GO3_FILM', { modifier: 'logo-go3', label: 'Go3' }],
    ['TELIA_TV_GO3_FILM_V2', { modifier: 'logo-go3', label: 'Go3' }],
    ['TELIA_TV_TEEMA_LASTELE_E', { modifier: 'teddybear' }],
    ['TELIA_TV_HBO_E', { modifier: 'hbo', label: 'h b o' }],
    ['TELIA_TV_HBO_MAX_E', { modifier: 'logo-hbomax-ver', label: 'h b o max' }],
    ['TELIA_TV_NATGEO+_E', { modifier: 'packet-ng', label: 'National Geographic' }],
    ['TELIA_TV_ESP_PLAYER_E', { modifier: 'logo-eurosport', label: 'Eurosport' }],
    ['TELIA_SETANTA_SPORTS_E', { modifier: 'logo-setanta', label: 'Setanta sports' }],
    ['TELIA_VIDEOLAENUTUS_E', { modifier: 'video' }],
    ['VIEWER_SLOTS', { modifier: 'tv-viewslot' }],
    ['TELIA_TV_TEEMA_HD_KANALID_E', { modifier: 'packet-hd' }],
    ['TELIA_TV_TEEMA_VIASATFILM_E', { modifier: 'packet-tv3', label: 'Tv3' }],
    ['TELIA_TV_TEEMA_DISCOVERY_E', { modifier: 'packet-discovery', label: 'Discovery' }],
    ['TELIA_TV_TEEMA_MUUSIKA_E', { modifier: 'music' }],
    ['TELIA_TV_TEEMA_VIASATFILMSPORT_E', { modifier: 'packet-tv3', label: 'Tv3' }],
    ['TELIA_TV_TEEMA_SPORT_E', { modifier: 'sport' }],
    ['TELIA_TV_TEEMA_UUDISED_E', { modifier: 'packet-news' }],
    ['TELIA_TV_TEEMA_DISNEY_E', { modifier: 'packet-disney', label: 'Disney' }],
    ['TELIA_TV_TEEMA_TAISKASVANUTELE_E', { modifier: 'packet-adults' }],
    ['TELIA_TV_TEEMA_ESIMENE_BALTI_PAKETT_E', { modifier: 'matryoshka' }],
    ['TELIA_TV_TEEMA_VIASATSPORT_E', { modifier: 'packet-tv3', label: 'Tv3' }],
    ['TELIA_TV_TEEMA_VIASATSPORT_A', { modifier: 'packet-tv3', label: 'Tv3' }],
    ['TELIA_TV_TEEMA_VIASATFILM_A', { modifier: 'packet-tv3', label: 'Tv3' }],
    ['TELIA_TV_TEEMA_VIASATFILMSPORT_A', { modifier: 'packet-tv3', label: 'Tv3' }],
    ['TELIA_TV_NOPPE_INFO_TV_A', { modifier: 'packet-info-tv' }],
    ['TELIA_TV_FILMIRIIUL_E', { modifier: 'inspira-plus-hor', label: 'inspira plus' }],
    ['TELIA_TV_GO3_APP_FILM_SPORT', { modifier: 'entertainment-film-sport' }],
    ['TELIA_TV_GO3_APP_FILM', { modifier: 'entertainment-film' }],
    ['TELIA_TV_GO3_APP_EXTRA_SPORT', { modifier: 'football' }],
    ['TELIA_TV_GO3_APP_SPORT', { modifier: 'sport' }],
    ['TELIA_TV_NETFLIX_STANDARD', { modifier: 'logo-netflix', label: 'Netflix' }],
    ['TELIA_TV_NETFLIX_PREMIUM', { modifier: 'logo-netflix', label: 'Netflix' }],
]);
export const getIconByService = (service, icons) => {
    return (icons && icons[service]) || DEFAULT_ICONS.get(service).modifier || null;
};
export const getIconsByServices = (serviceTitles) => {
    return serviceTitles.map((serviceTitle) => { var _a; return (_a = DEFAULT_ICONS.get(serviceTitle)) !== null && _a !== void 0 ? _a : null; });
};
